export class Colors {
  static white = '#fff';
  static primary = '#FF4C60';
  static success = 'rgba(0, 123, 92, 1)';
  static successSurface = '#aee9d1';
  static critical = '#ff0000';
  static criticalSurface = '#fed3d1';
  static info = 'rgba(215, 44, 13, 1)';
  static infoSurface = '#a4e8f2';
  static warning = '#FFD15C';
  static warningSurface = '#ffea8a';
  static secondary = '#6C6CE5';
  static secondarySurface = '#e4e5e7';
  static text = '#5E5C7F';
  static textSurface = '#8B88B1';
  static textSecondary = '#8B88B1';
  static textDisabled = '#8c9196';
  static textBold = '#454360';
}
